module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Bold_1_22660ae2.14d21754.eot";